module.exports = "/_next/static/images/BerthMorowaliMap-16cd07a72b36825c42b0c0ce716a3094.svg";